/* eslint-disable i18next/no-literal-string */
import CheckboxGroup from '@ingka/checkbox-group';
import FormField from '@ingka/form-field';
import type { Control, Path, FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Values = {
  emailSubscription: { emailMarketingEnabled: boolean; emailMarketingRequired: boolean };
};

export type ControlledEmailCheckboxesProps<TFormData extends Values = Values> = {
  control: Control<TFormData>;
  disabled?: boolean;
};

export const ControlledEmailCheckboxes = <TFormData extends Values = Values>({
  control,
}: ControlledEmailCheckboxesProps<TFormData>) => {
  const { t } = useTranslation();

  const emailCheckBoxes = [
    {
      id: 'emailMarketingEnabled',
      name: 'emailMarketingEnabled',
      label: t('form-email-checkbox-should-exist-label'),
    },
    {
      id: 'emailMarketingRequired',
      name: 'emailMarketingRequired',
      label: t('form-email-checkbox-is-required-label'),
      requires: 'emailMarketingEnabled',
    },
  ];

  const resetCheckboxWithRequirements = (id: string, checked: boolean) => {
    return emailCheckBoxes.reduce((acc, item) => {
      if (item.requires === id) {
        acc[item.id as keyof typeof acc] = false;
      }
      return acc;
    }, {} as Record<string, boolean>);
  };

  return (
    <Controller
      render={({ field: { onChange, onBlur, value } }) => {
        return (
          <FormField>
            <CheckboxGroup
              list={emailCheckBoxes.map((item) => ({
                ...item,
                checked: value[item.id as keyof typeof value],
                onBlur,
                disabled: item.requires && !value[item.requires as keyof typeof value],
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                  onChange({
                    ...(value as FieldValues),
                    ...resetCheckboxWithRequirements(item.id, e.currentTarget.checked),
                    [item.id]: e.currentTarget.checked,
                  });
                },
              }))}
            />
          </FormField>
        );
      }}
      name={'emailSubscription' as Path<TFormData>}
      control={control}
    />
  );
};
